<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>
    <ion-title>Register Closure Sale</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-item *ngIf='sales.count() == 0'>
    <ion-note>No sales to show</ion-note>
  </ion-item>

  <smr-sale-list
    [sales]="sales"
  >
  </smr-sale-list>
  
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccuredWhileLoadingSales" (click)="loadSales()"></salonmonster-tap-retry>

</ion-content>
